import { useParams, Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getDramasByCategory, dramas } from "@/mocks/dramas";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug);
  const displayDramas = slug === "remen"
    ? dramas
    : getDramasByCategory(slug || "");

  return (
    <main className="min-h-screen pt-20 pb-12">
      <div className="px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <nav className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-500 mb-6 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <span>/</span>
            <span className="text-foreground-800 font-medium whitespace-nowrap">
              {currentCategory?.name || "全部剧集"}
            </span>
          </nav>

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
              {currentCategory?.name || "全部剧集"}
            </h1>
            <p className="text-sm text-foreground-500">
              共 {displayDramas.length} 部剧集
            </p>
          </div>

          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 md:pb-0">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  slug === cat.slug
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {displayDramas.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
              {displayDramas.map((drama) => (
                <Link
                  key={drama.id}
                  to={`/article/${drama.slug}`}
                  className="group cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-xl mb-3 aspect-[3/4]">
                    <img
                      src={drama.coverImage}
                      alt={drama.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute top-2 right-2">
                      <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-black/60 text-background-50 backdrop-blur-sm whitespace-nowrap">
                        {drama.rating}
                      </span>
                    </div>
                    {drama.featured && (
                      <div className="absolute top-2 left-2">
                        <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                          热播
                        </span>
                      </div>
                    )}
                    <div className="absolute bottom-2 left-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                        <i className="ri-play-fill text-sm"></i>
                        立即观看
                      </span>
                    </div>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading truncate group-hover:text-primary-600 transition-colors duration-200">
                    {drama.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                    {drama.year} · {drama.updateInfo}
                  </p>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                <i className="ri-movie-2-line text-3xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-700 mb-2">
                暂无剧集
              </h3>
              <p className="text-sm text-foreground-500 mb-6">
                该分类下暂时没有内容，敬请期待更多精彩剧集上线
              </p>
              <Link
                to="/category/remen"
                className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                浏览热门推荐
              </Link>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}